import apiClient from '@/utils/request'
import { IGeneralResponse } from '@/api/types'
import { serialize } from 'object-to-formdata'
import type { AxiosRequestConfig } from 'axios'

export interface IContact {
  id: string
  type: 'contact'
  attributes: IContactAttributes
}

export interface IContactAttributes {
  type: string
  first_name: string
  last_name: string
  middle_name?: string
  email: string
  country_code: string
  country_id: number
  postal_code?: string
  city: string
  address: string
  room: string
  phone: string
  birthday: string
  company_name?: string
  registration_number?: string
  with_agreement?: boolean
  with_profile_verification?: boolean
  vat_payer: boolean
  representative_first_name?: string
  representative_last_name?: string
  position?: string
  tin?: string
  vat?: string
  docs_needed: boolean
  verification_url?: string
  verification_present?: boolean
  verification_failed?: boolean
  verification_not_finished?: boolean
  verification_submitted?: boolean
  verified?: boolean
}

interface IContactResponse extends IGeneralResponse {
  data: IContact
}

export interface IContactDocuments {
  files: File[]
}

export const fetchItem = async (
  config?: AxiosRequestConfig
): Promise<IContactResponse> => {
  const response = await apiClient.get<IContactResponse>('/contact', config)
  return response.data
}

export const saveItem = async (
  params: IContactAttributes
): Promise<IContactResponse> => {
  const response = await apiClient.post<IContactResponse>('/contact', params)
  return response.data
}

export const uploadDocuments = async (
  payload: IContactDocuments
): Promise<IContactResponse> => {
  const options = {
    indices: false,
    allowEmptyArrays: true
  }
  const form = serialize(payload, options)
  const response = await apiClient.post<IContactResponse>(
    '/contact/upload_documents',
    form
  )
  return response.data
}
